'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalRequestArchiveComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentalRequestArchiveComponent = exports.rentalRequestArchiveComponent = {
    template: require('./rental-request-archive.html'),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<'
    },
    controller: ["$scope", "$state", "rentalProductsService", "config", "common", "gettextCatalog", "Paging", "$stateParams", "authService", "Analytics", function rentalRequestArchiveController($scope, $state, rentalProductsService, config, common, gettextCatalog, Paging, $stateParams, authService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.search = search;
        vm.clear = clear;
        vm.isSearchUsed = isSearchUsed;
        vm.goToPage = goToPage;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.pageCountList = [12, 24, 36];
        vm.model = null;
        vm.ordersLoading = false;
        vm.years = [];
        vm.paging = Paging.create({
            page: 1,
            itemsPerPage: parseInt($stateParams.pageSize) || vm.pageCountList[0],
            totalItems: 0
        });
        vm.getDownloadUrl = getDownloadUrl;

        function init() {
            common.setTitle(gettextCatalog.getString('All my rental requests'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals/request-archive', gettextCatalog.getString('All my rental requests'));

            var currentYear = (0, _moment2.default)().get('year');
            var minYear = 2019;
            vm.years = Array.from({ length: currentYear - minYear + 1 }, function (v, i) {
                return currentYear - i;
            });

            loadOrders(vm.paging.itemsPerPage).then(function () {
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                loadOrders(vm.paging.itemsPerPage);
            });
        }

        function loadOrders(itemsPerPage) {
            vm.ordersLoading = true;

            var params = getQueryStringParams(itemsPerPage);

            return rentalProductsService.searchRentalOrders(params).then(function (response) {
                vm.model = response;
                vm.paging = Paging.create({
                    page: params.page,
                    itemsPerPage: vm.paging.itemsPerPage,
                    totalItems: response.count
                });
                vm.ordersLoading = false;
            });
        }

        function getDownloadUrl(rentalOrder) {
            return config.webApiBaseUrl + ('report/rentalOrderDetail/' + rentalOrder.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function getQueryStringParams(itemsPerPage) {
            var page = parseInt($stateParams.page);

            return {
                page: page,
                skip: vm.paging.getSkipValue(page, itemsPerPage),
                take: itemsPerPage,
                product: $stateParams.product,
                year: $stateParams.year
            };
        }

        function search(page) {
            $state.go('.', {
                page: page || 1,
                pageSize: vm.paging.itemsPerPage,
                product: vm.model.search.product,
                year: vm.model.search.year
            });
        }

        function clear() {
            vm.model.search.product = null;
            vm.model.search.year = null;

            search();
        }

        function isSearchUsed() {
            return isNullOrEmpty($stateParams.statusId) || isNullOrEmpty($stateParams.product) || isNullOrEmpty($stateParams.remark) || isNullOrEmpty($stateParams.year) || isNullOrEmpty($stateParams.depositRefunded);
        }

        function isNullOrEmpty(str) {
            return !!str && str.length > 0;
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            search(page);
        }

        function changeItemsPerPage(itemsPerPage) {
            vm.paging.itemsPerPage = itemsPerPage;
            search();
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/rental-request-archive.js
// module id = 889
// module chunks = 0